import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";
import { timestamps } from "../utils/fields";

export const offlinePlaylists = sqliteTable("offline_playlists", {
  ...timestamps,
  id: text("id").primaryKey(),
  title: text("title").notNull(),
  image: text("image"),
  visibility: text("visibility", {
    enum: ["public", "private"],
  })
    .notNull()
    .default("private"),
  hasPrivateSong: integer("has_private_song", { mode: "boolean" }).notNull(),
  privateSongIds: text("private_song_ids", { mode: "json" })
    .notNull()
    .default("[]")
    .$type<string[]>(),
  userId: text("user_id").notNull(),
  userName: text("user_name").notNull(),
});

export type OfflinePlaylist = typeof offlinePlaylists.$inferSelect;
